<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div style="margin-bottom: 10px">
        <el-radio-group v-model="table.params.type" @change="handleTabs">
          <el-radio-button :label="1">用户列表</el-radio-button>
          <el-radio-button :label="2">冻结用户</el-radio-button>
        </el-radio-group>
      </div>
      <div class="flex" style="margin-bottom: 10px">
        <el-form
          ref="elFormDom"
          inline
          :model="table.params"
          size="small"
          class="flex"
          @submit.native.prevent="handleSearch"
        >
          <el-form-item label="注册时间" prop="reg_time">
            <el-date-picker
              style="width: 250px"
              v-model="table.params.reg_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="入会时间" prop="vip_time">
            <el-date-picker
              style="width: 250px"
              v-model="table.params.vip_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否会员" prop="is_vip">
            <el-select
              v-model="table.params.is_vip"
              placeholder="请选择"
              clearable
              @change="handleSearch"
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option label="会员" :value="1"></el-option>
              <el-option label="非会员" :value="2"></el-option>
              <!-- <el-option label="会员卡" :value="3"></el-option>
              <el-option label="体验会员" :value="2"></el-option>
              <el-option label="非会员" :value="-1"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="完善简历" prop="perfect_resume">
            <el-select
              v-model="table.params.perfect_resume"
              clearable
              @change="handleSearch"
            >
              <el-option label="已创建简历" :value="1"></el-option>
              <el-option label="未创建简历" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否公开" prop="is_open">
            <el-select
              v-model="table.params.is_open"
              clearable
              @change="handleSearch"
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="加入诚信保" prop="is_honesty">
            <el-select
              v-model="table.params.is_honesty"
              clearable
              @change="handleSearch"
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学校" prop="school_id">
            <el-select
              v-model="table.params.school_id"
              clearable
              filterable
              @change="handleSearch"
            >
             <el-option
              v-for="item in schoolOption"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="已上传附件" prop="has_attach_resume">
            <el-select
              v-model="table.params.has_attach_resume"
              clearable
              @change="handleSearch"
            >
              <!-- <el-option label="全部" :value="0"></el-option> -->
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="keyword">
            <el-input
              clearable
              v-model="table.params.keyword"
              placeholder="请输入关键字"
              @keyup.enter.native.prevent="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-button type="text" @click="handleissuedVip">
        批量赠送会员卡 
      </el-button>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        title=""
        addText="添加"
        :field="field"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        showSelect
        :selectable="(row) => true"
      >
        <template v-slot:sex="{ row }">
          <span>{{
            row.sex === 0 ? "未填" : row.sex === 1 ? "男" : "女"
          }}</span>
        </template>
        <template v-slot:attach_resume_count="{ row }">
          <span v-if="row.attach_resume_count == 0">{{row.attach_resume_count}}份</span>
          <el-popover
            v-else
            placement="left"
            @show='handleAttachResume(row)'
            @hide="handleAttachResumeHide(row)"
            trigger="click">
              <div style="display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;">
                <el-button @click="viewPdf(item)" type="text" v-for="(item, index) in attach_list" :key="index">{{item.name}}</el-button>
              </div>
            <el-button slot="reference" type="text">{{row.attach_resume_count}}份</el-button>
          </el-popover>
        </template>
        <template v-slot:is_vip="{ row }">
          <el-button type="text" @click="viewVipLog(row)">
            {{
              row.is_vip == 1
                ? { 0: "非会员", 1: "会员", 2: "体验会员", 3: "会员卡" }[
                    row.vip_type
                  ]
                : "非会员"
            }}
          </el-button>
          <!-- <el-button
            v-if="
              (row.vip_type == 0 || row.vip_type == 2) &&
              row.perfect == 1 &&
              row.perfect_resume == 1 &&
              row.vip_card_issue_at
            "
            type="text"
            size="mini"
            class="delBtn"
            >（未领取会员卡）</el-button
          > -->
        </template>
        <template v-slot:device_type="{ row }">
            {{
              {1:'小程序',2:'ios',3:'安卓',4:'支付宝小程序',5:'支付宝lot设置',6:'web端'}[row.device_type] || ''
            }}
        </template>
        <template v-slot:is_open="{ row }">
          <span>{{ { 1: "是", 0: "否" }[row.is_open] }}</span>
        </template>
        <template v-slot:is_honesty="{ row }">
          <span>{{ { 1: "是", 2: "否" }[row.is_honesty] }}</span>
        </template>
        <template v-slot:action="{ row }">
          <!-- <el-button v-if="row.perfect == 1" type="text" size="mini" @click="pushPage(row, 1)">查看简历</el-button>  -->
          <el-button
            v-if="row.perfect == 1 && row.perfect_resume == 1"
            type="text"
            size="mini"
            @click="showEdit(row)"
            >查看简历</el-button
          >&nbsp;&nbsp;
          <el-dropdown>
            <el-button type="text" size="mini"
              >更多 <i class="el-icon-arrow-down el-icon--right"></i
            ></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-if="row.perfect == 1 && row.perfect_resume == 1"
              >
                <el-button type="text" size="mini" @click="pushPage(row, 2)"
                  >投递记录</el-button
                >
              </el-dropdown-item>
              <!-- v-if="
                  (row.vip_type == 0 || row.vip_type == 2) &&
                  row.perfect == 1 &&
                  row.perfect_resume == 1 &&
                  !row.vip_card_issue_at
                " -->
              <el-dropdown-item>
                <el-button
                  type="text"
                  size="mini"
                  @click="handleissuedVip1(row)"
                  >赠送会员</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item v-if="row.is_freeze === 1">
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-warning-outline"
                  class="delBtn"
                  @click="handleFreeze(row, 1)"
                  >冻结</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item v-if="row.is_freeze === 2">
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-circle-check"
                  @click="handleFreeze(row, 2)"
                  >解冻</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="text"
                  size="mini"
                  @click="handleHideResume(row)"
                  >{{ row.is_open == 1 ? '隐藏简历' : '显示简历' }}</el-button
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button
            v-if="row.perfect == 1 && row.perfect_resume == 1"
            type="text"
            size="mini"
            @click="pushPage(row, 2)"
            >操作记录</el-button
          >
          <el-button
            v-if="
              (row.vip_type == 0 || row.vip_type == 2) &&
              row.perfect == 1 &&
              row.perfect_resume == 1 &&
              !row.vip_card_issue_at
            "
            type="text"
            size="mini"
            @click="handleissuedVip1(row)"
            >赠送会员</el-button
          >
          <el-button
            v-if="
              (row.vip_type == 0 || row.vip_type == 2) &&
              row.perfect == 1 &&
              row.perfect_resume == 1 &&
              row.vip_card_issue_at
            "
            type="text"
            size="mini"
            class="delBtn"
            >未领取会员卡</el-button
          >
          <el-button
            v-if="row.is_freeze === 1"
            type="text"
            size="mini"
            icon="el-icon-warning-outline"
            class="delBtn"
            @click="handleFreeze(row, 1)"
            >冻结</el-button
          >
          <el-button
            v-if="row.is_freeze === 2"
            type="text"
            size="mini"
            icon="el-icon-circle-check"
            @click="handleFreeze(row, 2)"
            >解冻</el-button
          > -->
        </template>
      </VTable>
    </div>

    <detail ref="detail"></detail>

    <!-- 查看简历 -->
    <edit ref="edit"></edit>
    <giveVipDialog ref="giveVipDialogRef" @refresh="getTable"></giveVipDialog>
    <batchGiveVip ref="batchGiveVipRef" @refresh="getTable"></batchGiveVip>
    <vipLog ref="vipLogRef"></vipLog>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import Detail from "./components/Detail.vue";
import Edit from "./components/Edit.vue";
import { mixinTable } from "@/mixins/table.js";
import giveVipDialog from "./components/giveVipDialog.vue";
import batchGiveVip from "./components/batchGiveVip.vue";
import vipLog from "./components/vipLog.vue";
export default {
  name: "UserList",
  mixins: [mixinTable],
  components: {
    VTable,
    Detail,
    Edit,
    giveVipDialog,
    batchGiveVip,
    vipLog
  },
  data() {
    return {
      field: [
        { name: "name", label: "用户名", hidden: false },
        { name: "account", label: "手机号", width: "120", hidden: false },
        { name: "sex", label: "性别", width: "60", hidden: false },
        { name: "school_name", label: "大学名称", hidden: false },
        { name: "education", label: "学历", hidden: false },
        { name: "major_name", label: "专业", hidden: false },
        { name: "agent_name", label: "邀请人", hidden: false },
        { name: "device_type", label: "来源", hidden: false },
        { name: "create_time", label: "注册日期", width: "160", hidden: false },
        { name: "is_vip", label: "是否会员", width: "180", hidden: false },
        { name: "is_open", label: "是否公开", hidden: false },
        {
          name: "is_honesty",
          label: "加入诚信保",
          width: "200",
          hidden: false,
        },
        {
          name: "attach_resume_count",
          label: "附件简历",
          width: "120",
          hidden: false,
        },
        {
          name: "action",
          label: "操作",
          fixed: "right",
          width: "130",
          hidden: false,
        },
      ],
      table: {
        loading: false,
        params: {
          has_attach_resume:'',
          keyword: "",
          reg_time: [],
          vip_time: [],
          is_vip: "",
          is_open: 0,
          is_honesty: 0,
          type: 1, // 类型 1:正常 2:冻结
          perfect_resume: 1, // 是否完善简历
          school_id:'',
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      multipleSelection: [],
      schoolOption:[],
      attach_list:[],
    };
  },
  created() {
    this.getTable();
    this.getSchoolOption();
  },
  methods: {
    handleAttachResume(row) {
      this.$http.get("/admin/user/attachList", { params: {id:row.id} }).then(res =>{
        if(res.code == 1){
          this.attach_list = res.data.list;
        }
      })
    },
    handleAttachResumeHide() {
      this.attach_list = []
    },
    viewPdf(item){
      window.open(item.path,'_blank')
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleissuedVip() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("请选择用户");
        return;
      }
      let dom = this.$refs.batchGiveVipRef;
      dom.toggle(true);
      dom.getDetail(this.multipleSelection);
    },
    handleissuedVip1(row) {
      let dom = this.$refs.giveVipDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
      // this.$confirm(`确定赠送【${row.name}】会员卡吗？`, "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      // })
      //   .then(() => {
      //     this.$http
      //       .post("admin/user/issuedVip", {
      //         id: row.id,
      //       })
      //       .then((res) => {
      //         if (res.code === 1) {
      //           this.$message.success("操作成功！");
      //           this.getTable();
      //         } else {
      //           this.$message.error(res.msg);
      //         }
      //       });
      //   })
      //   .catch(() => {});
    },
    getTable() {
      console.log(this.table.params, "dd");
      let _params = {
        ...this.table.params,
        reg_time: this.table.params.reg_time
          ? this.table.params.reg_time.join("|")
          : "",
        vip_time: this.table.params.vip_time
          ? this.table.params.vip_time.join("|")
          : "",
      };
      console.log(_params, "_params");
      this.$http.get("/admin/user/list", { params: _params }).then((res) => {
        if (res.code === 1) {
          this.table.data = res.data.list;
          this.table.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 切换状态
    handleTabs() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // 查看
    showDetail(row) {
      let dom = this.$refs.detail;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },

    //  1冻结、2解冻
    handleFreeze(row, type) {
      let str = type === 1 ? "冻结" : "解冻";
      let _params = {
        id: row.id,
        type: type,
      };
      this.$confirm(`请确认是否${str}该数据？`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$http.post("admin/user/operation", _params).then((res) => {
            if (res.code === 1) {
              this.$message.success("操作成功！");
              this.getTable();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleHideResume(row) {
      let _params = {
        id: row.id,
      };
      let str = row.is_open == 1 ? '隐藏' : '显示';
      this.$confirm(`请确认是否${str}该简历？`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$http.post("admin/user/hide", _params).then((res) => {
            if (res.code === 1) {
              this.$message.success("操作成功！");
              this.getTable();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 操作记录 type:1简历、2.操作记录  perfect=1的时候才有简历
    pushPage(row, type) {
      if (row.perfect != 1 && type === 1) {
        this.$message.warning("该用户未完善简历");
        return;
      } else {
        sessionStorage.setItem("userId", row.id);
        let _url = type === 1 ? "/userInfo" : "/recordList";
        this.$router.push(_url);
      }
    },
    // 查看简历
    showEdit(row) {
      let dom = this.$refs.edit;
      dom.toggle(true);
      dom.getUserInfo(row);
      dom = null;
    },
    viewVipLog(row) {
      let dom = this.$refs.vipLogRef;
      dom.toggle(true);
      dom.getDetail(row);
    }
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  position: relative;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    // display: flex;
    // justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
</style>